import { render, staticRenderFns } from "./app.vue?vue&type=template&id=5d87e7ea"
import script from "./app.vue?vue&type=script&lang=js"
export * from "./app.vue?vue&type=script&lang=js"
import style0 from "./app.vue?vue&type=style&index=0&id=5d87e7ea&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d87e7ea')) {
      api.createRecord('5d87e7ea', component.options)
    } else {
      api.reload('5d87e7ea', component.options)
    }
    module.hot.accept("./app.vue?vue&type=template&id=5d87e7ea", function () {
      api.rerender('5d87e7ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/app.vue"
export default component.exports